import { CheckIcon } from '@radix-ui/react-icons';

import { useThemeContext } from '../../../../contexts/ThemeContext';
import { resolveColor } from '../../theme/utils/resolveColor';
import { PoweredByQITech } from '../components/PoweredByQITech';
import * as S from './styles';

interface SignedPageProps {
    signData: any;
}

export const PrivatePayrollAuctionSignedPage = ({ signData }: SignedPageProps) => {
    const { clientThemeSettings } = useThemeContext();
    const primary = resolveColor('primary', clientThemeSettings);
    const text = resolveColor('text', clientThemeSettings)

    const callbackUrl = signData?.signer_data?.callback_url;

    return (
        <S.PageWrapper>
            <S.LogoSection>
                {clientThemeSettings?.logo_url && (
                    <S.LogoImage src={clientThemeSettings.logo_url} alt="logo" />
                )}
            </S.LogoSection>

            <S.Content>
                <S.CheckCircle $color={primary}>
                    <CheckIcon width={48} height={48} color={primary} />
                </S.CheckCircle>

                <S.Title $text={text}>
                    Recebemos sua proposta e já estamos analisando
                </S.Title>

                <S.Subtitle>
                    Se for aprovada, o valor será depositado direto na sua conta.
                </S.Subtitle>
            </S.Content>

            <S.Separator />

            {callbackUrl ? (
            <S.ContactSection>
                <S.ContactText>
                    Para dúvidas e acompanhamento da proposta acesse{' '}
                        <S.ContactLink href={callbackUrl} $color={primary} target="_blank" rel="noopener noreferrer">
                            {callbackUrl}
                        </S.ContactLink>
                        .
                </S.ContactText>
            </S.ContactSection>
            ) : null}
            <S.Footer>
                <PoweredByQITech />
            </S.Footer>
        </S.PageWrapper>
    );
};
